export default "__VITE_ASSET__Bw9oNAM0__"